import { getBorderColor as getGlobalBorderColor } from './global';
import { getBackgroundColor as getGlobalBackgroundColor } from '../../../backgroundColor/themes/Light/global';
import { DATA_STATE_CANCELLED, DATA_STATE_COMPLETED, DATA_STATE_CURRENT, DATA_STATE_INVALID, DATA_STATE_IS_TODAY, DATA_STATE_READ_ONLY, DATA_STATE_SELECTED, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_EXPANDED, INTERACTION_STATE_HOVER, } from '../../../../constants';
export function getBorderColor(transformer) {
    const globalBorderColor = getGlobalBorderColor(transformer);
    const globalBackgroundColor = getGlobalBackgroundColor(transformer);
    return Object.freeze({
        /** @deprecated use contentContainer.* */
        container: { value: globalBorderColor.sand200 },
        contentContainer: {
            default: { value: globalBorderColor.sand200 },
            tinted: { value: globalBorderColor.sand200 },
        },
        containerDragAndDrop: { value: globalBorderColor.gray600 },
        modal: { value: globalBorderColor.sand200 },
        menuItem: {
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalBorderColor.brand.mediumOrange },
            },
        },
        form: {
            input: {
                default: { value: globalBorderColor.gray600 },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalBorderColor.gray1000 },
                },
                dataStates: {
                    [DATA_STATE_INVALID]: { value: globalBorderColor.darkOrange700 },
                    [DATA_STATE_READ_ONLY]: { value: globalBorderColor.transparent },
                },
            },
            amountInput: {
                default: { value: globalBorderColor.transparent },
            },
            datepicker: {
                date: {
                    default: { value: globalBorderColor.transparent },
                    interactionStates: {
                        [INTERACTION_STATE_HOVER]: {
                            value: globalBorderColor.sand100,
                        },
                    },
                    dataStates: {
                        [DATA_STATE_IS_TODAY]: { value: globalBorderColor.sand200 },
                        [DATA_STATE_SELECTED]: {
                            value: globalBorderColor.brand.mediumOrange,
                        },
                    },
                },
            },
            toggleButton: {
                default: { value: globalBorderColor.sand200 },
            },
            slider: {
                knob: {
                    default: { value: globalBorderColor.brand.mediumOrange },
                },
            },
        },
        button: {
            plain: {
                withBorder: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: {
                            value: globalBorderColor.brand.mediumOrange,
                        },
                    },
                },
            },
            secondary: {
                default: { value: globalBorderColor.gray1000 },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBorderColor.brand.mediumOrange,
                    },
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBorderColor.brand.mediumOrange,
                    },
                },
            },
            add: {
                default: { value: globalBorderColor.gray1000 },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBorderColor.brand.mediumOrange,
                    },
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBorderColor.brand.mediumOrange,
                    },
                },
            },
        },
        divider: { value: globalBorderColor.sand200 },
        collapsibleSection: {
            interactionStates: {
                [INTERACTION_STATE_EXPANDED]: {
                    value: globalBorderColor.sand200,
                },
            },
        },
        popover: { value: globalBackgroundColor.sand200 },
        pipeline: {
            stepContent: {
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalBorderColor.brand.mediumOrange },
                },
            },
            indicator: {
                default: { value: globalBorderColor.sand200 },
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalBorderColor.brand.mediumOrange },
                    [DATA_STATE_COMPLETED]: { value: globalBorderColor.transparent },
                    [DATA_STATE_CANCELLED]: { value: globalBorderColor.darkOrange700 },
                },
            },
        },
        connectorLine: {
            default: { value: globalBorderColor.sand200 },
            dataStates: {
                [DATA_STATE_COMPLETED]: { value: globalBorderColor.brand.mediumOrange },
                [DATA_STATE_CURRENT]: { value: globalBorderColor.sand200 },
            },
        },
        table: {
            header: { value: globalBorderColor.gray800 },
            cell: { value: globalBorderColor.sand200 },
        },
        stepIndicator: {
            indicator: {
                default: { value: globalBorderColor.sand200 },
                dataStates: {
                    [DATA_STATE_COMPLETED]: { value: globalBorderColor.brand.mediumOrange },
                    [DATA_STATE_CURRENT]: { value: globalBorderColor.brand.mediumOrange },
                },
            },
        },
        circle: {
            smallAttentional: { value: globalBorderColor.brand.mediumOrange },
        },
    });
}
